import { AppAuthenticationState } from '@dxb-web-ui-framework/iam/contexts/AppAuthentication/types';
import Keycloak, { KeycloakInstance } from 'keycloak-js';
import { isNotProductionMode } from '@dxb-web-ui-framework/common/domain/Environment/EnvironmentService';

const keycloak = (url: string) =>
  Keycloak({
    realm: 'ecommbx',
    clientId: isNotProductionMode() ? 'web-client-local-dev' : 'web-client',
    url,
  });

const keycloakInstanceToAppAuthenticationProviderProps = (
  { authenticated, idToken, token, refreshToken, updateToken, logout, tokenParsed }: KeycloakInstance,
  idleTimeout: number,
  idleTimerEnabled: boolean,
  timerExpirationHandler: 'idle-timer-hook' | 'use-timeout-hook',
): AppAuthenticationState | undefined =>
  ({
    authenticated: authenticated ?? false,
    token: token ?? undefined,
    idToken: idToken ?? undefined,
    refreshToken: refreshToken ?? undefined,
    tokenParsed: tokenParsed ?? undefined,
    idleTimeout,
    logout,
    updateToken,
    idleTimerEnabled,
    timerExpirationHandler,
  } as any);

export { keycloak, keycloakInstanceToAppAuthenticationProviderProps };
